import dayjs from "dayjs";
import * as React from "react";
import { YODHA_COLORS } from "../constants/colours";

interface PeriodModifierProps {
  currentView: dayjs.ManipulateType;
  setCurrentView: React.Dispatch<React.SetStateAction<dayjs.ManipulateType>>;
}

const PeriodModifier = ({
  currentView,
  setCurrentView,
}: PeriodModifierProps) => {
  return (
    <div className="flex flex-row box-border border-4 rounded-l-lg rounded-r-lg mt-5">
      <div
        onClick={() => setCurrentView("day")}
        className="border-r-4 p-4 w-2/6 flex justify-center cursor-pointer font-semibold"
        style={{
          background: currentView === "day" ? "#fff" : YODHA_COLORS.grey,
          color:
            currentView === "day"
              ? YODHA_COLORS.darkGrey
              : YODHA_COLORS.greyAlt,
        }}
      >
        DAY
      </div>
      <div
        onClick={() => setCurrentView("week")}
        className="border-r-4 p-4 w-2/6 flex justify-center cursor-pointer font-semibold"
        style={{
          background: currentView === "week" ? "#fff" : YODHA_COLORS.grey,
          color:
            currentView === "week"
              ? YODHA_COLORS.darkGrey
              : YODHA_COLORS.greyAlt,
        }}
      >
        WEEK
      </div>
      <div
        onClick={() => setCurrentView("month")}
        className="p-4 w-2/6 flex justify-center cursor-pointer font-semibold"
        style={{
          background: currentView === "month" ? "#fff" : YODHA_COLORS.grey,
          color:
            currentView === "month"
              ? YODHA_COLORS.darkGrey
              : YODHA_COLORS.greyAlt,
        }}
      >
        MONTH
      </div>
    </div>
  );
};

export default PeriodModifier;
